// import http from "../utils/http";
import request from '@/axios'

export const getConfig = (data) => {
  return request({
    url: '/aiAgent/config/get',
    data
  })
}

// 批量分析
export const getBatchAnalyze = (data) => {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/batchAnalyze',
    data
  })
}

// 获取一周中哪些天数是有建议的
export const getAdviceDayList = (data) => {
  return request({
    url: '/inside/ai/advice/getAdviceDayList',
    data
  })
}

// 获取指定天数的建议列表
export const getAdviceList = (data) => {
  return request({
    url: '/inside/ai/advice/getAdviceList',
    data
  })
}

// 更新建议
export const updateAdvice = (data) => {
  return request({
    url: '/inside/ai/advice/updateAdvice',
    data
  })
}

// 发送聊天信息
export const createTask = (data) => {
  return request({
    url: '/inside/ai/chat/createTask',
    data
  })
}

// 获取聊天记录
export const getChatRecordList = (data) => {
  return request({
    url: '/inside/ai/chat/record/getChatRecordList',
    data
  })
}

// 获取会议助手模板列表
export const getSummaryRuleList = () => {
  return request({
    url: '/inside/ai/chat/record/business/getMeetingRules',
    data: {
      checkEnableTag: true
    }
  })
}

// 检查是否开启定位权限白名单
export const getLocationSetting = (data) => {
  return request({
    url: '/inside/ai/chat/record/business/getLocationSetting',
    data
  })
}

export const getCustomerList = (data) => {
  return request({
    url: '/inside/ai/chat/record/getChatRecordCustomerList',
    data
  })
}

export const getAiAnalyseBusinessDataList = (data) => {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/getAiAnalyseBusinessDataList',
    data
  })
}

export const addCustomerCommunicate = (data) => {
  return request({
    url: '/inside/ai/chat/record/addCustomerCommunicate',
    data
  })
}

export const relyCommunicatePlan = (data) => {
  return request({
    url: '/inside/ai/chat/record/business/blindCommunicateAndPlan',
    data
  })
}

export const getCommunicatePlanList = (data) => {
  return request({
    url: '/inside/ai/chat/record/business/getCommunicatePlanList',
    data
  })
}

export const getCommunicatePlanBaseInfo = (data) => {
  return request({
    url: '/inside/ai/chat/record/addCommunicatePlan',
    data
  })
}

export const createTodoSuggest = (data) => {
  return request({
    url: '/inside/ai/chat/record/createTodoSuggest',
    data
  })
}

export const getSseMsg = (data) => {
  return request({
    url: '/inside/ai/chat/getSseMsg',
    data
  })
}

// 获取新建客户跟进记录需要的信息
export const getCustomRecordInfo = (data) => {
  return request({
    url: '/inside/ai/chat/record/business/getBaseInfo',
    data
  })
}

// taskId换behavingId
export const getBehavingId = (data) => {
  return request({
    url: '/inside/customerReview/getBehavingId',
    data
  })
}

// 获取默认填充信息
export const getFormInfo = (data) => {
  return request({
    url: '/inside/ai/chat/record/business/getDefaultCustomerCommunicate',
    data
  })
}

// 获取ai菜单
export function getAiMenu(data) {
  return request({
    url: '/inside/ai/menu/list',
    data
  })
}

// 获取初始化配置
export function getInitializationList(data) {
  return request({
    url: '/inside/initialization/list',
    data
  })
}

// 更新初始化配置
export function editInitialization(data) {
  return request({
    url: '/inside/initialization/edit',
    data
  })
}

// 检查初始化步骤是否已完成
export function checkInitializationComplete(data) {
  return request({
    url: '/inside/initialization/checkComplete',
    data
  })
}

// AI 自动初始化
export function autoInitialization(data) {
  return request({
    url: '/inside/initialization/autoInitialization',
    data
  })
}

// 获取移动端token（多平台需要）
export function getMobileToken(data) {
  return request({
    url: '/im/session/record/get/token',
    method: 'post',
    data
  })
}

// 试用申请
export function getFreeTrial(data) {
  return request({
    url: '/app/ai/scanQr/freeTrial',
    method: 'post',
    data
  })
}

// 获取接入列表
export const getServiceAccessList = (data) => {
  return request({
    url: '/inside/access/list',
    data
  })
}

// 获取工牌列表
export const getBadgeList = (data) => {
  return request({
    url: '/inside/badge/list',
    data
  })
}

// 工牌绑定
export const bindBadgeInfo = (data) => {
  return request({
    url: '/inside/badge/bind',
    data
  })
}

// 工牌解绑
export const unbindBadgeInfo = (data) => {
  return request({
    url: '/inside/badge/unbind',
    data
  })
}

// 工牌录音列表查询
export const getRecordList = (data) => {
  return request({
    url: '/inside/badge/record/list/v2',
    data
  })
}

// 录音作废
export const getRecordExpire = (data) => {
  return request({
    url: '/inside/badge/expire',
    data
  })
}

// 工牌启用状态
export const getBadgeOpenStatus = (data) => {
  return request({
    url: '/inside/badge/open/status',
    data
  })
}

// 权限校验
export function checkLicense(data) {
  return request({
    url: '/inside/ai/fee/checkLicense',
    method: 'post',
    data
  })
}

// 获取AI权限
export function getAiLicense(data) {
  return request({
    url: '/inside/ai/fee/getAiLicense',
    method: 'post',
    data
  })
}

// 获取质量分析配置信息
export function getMeetingAssistantConfig(data) {
  return request({
    url: '/inside/ai/meetingAssistantConfig/get',
    method: 'post',
    data
  })
}

// 更新质量分析配置信息
export function updateMeetingAssistantConfig(data) {
  return request({
    url: '/inside/ai/meetingAssistantConfig/update',
    method: 'post',
    data
  })
}

// 标记设备录音已发送
export function sendBadge(data) {
  return request({
    url: '/inside/badge/send',
    method: 'post',
    data
  })
}
// 销售成长助手-更新添加学习计划
export function addStudyPlan(data) {
  return request({
    url: '/inside/ai/chat/record/addStudyPlan',
    method: 'post',
    data
  })
}
// 员工表现分析-更新学习计划
export function updateStudyPlan(data) {
  return request({
    url: '/inside/ai/sales/growth/addStudyPlan',
    method: 'post',
    data
  })
}
// 终止当前分析
export function terminationAnalyze(data) {
  return request({
    url: '/inside/ai/aiCustomerAnalyst/termination',
    method: 'post',
    data
  })
}
// 获取指定AI助理下的行业
export function getIndustryList(data) {
  return request({
    url: '/inside/ai/prompt/getIndustryList',
    method: 'post',
    data
  })
}
// 获取指定行业下的所有场景
export function getSceneList(data) {
  return request({
    url: '/inside/ai/prompt/getSceneList',
    method: 'post',
    data
  })
}
// 获取指定场景下的所有提示词
export function getPromptList(data) {
  return request({
    url: '/inside/ai/prompt/getPromptTemplateList',
    method: 'post',
    data
  })
}

// 获取公司的质量分析规则
export function getQualityAnalysisRule(data) {
  return request({
    url: '/inside/ai/qualityAnalysisRule/get',
    method: 'post',
    data
  })
}

// 更新公司的质量分析规则
export function updateQualityAnalysisRule(data) {
  return request({
    url: '/inside/ai/qualityAnalysisRule/update',
    method: 'post',
    data
  })
}
// 获取员工表现分析规则列表
export function getAnalysisConfigList(data) {
  return request({
    url: '/inside/analysisConfig/getPerformanceConfig',
    method: 'post',
    data
  })
}
// 排序员工表现分析规则列表
export function updatePerformanceConfigSort(data) {
  return request({
    url: '/inside/analysisConfig/updatePerformanceConfigSort',
    method: 'post',
    data
  })
}
// 更新员工表现分析规则
export function updatePerformanceConfigDetail(data) {
  return request({
    url: '/inside/analysisConfig/updatePerformanceConfigDetail',
    method: 'post',
    data
  })
}
// 删除员工表现分析规则
export function deletePerformanceConfigDetail(data) {
  return request({
    url: '/inside/analysisConfig/deletePerformanceConfigDetail',
    method: 'post',
    data
  })
}
// 查询员工表现分析规则详情
export function getPerformanceConfigDetail(data) {
  return request({
    url: '/inside/analysisConfig/getPerformanceConfigDetail',
    method: 'post',
    data
  })
}
// 开启或关闭员工表现分析
export function updatePerformanceConfig(data) {
  return request({
    url: '/inside/analysisConfig/updatePerformanceConfig',
    method: 'post',
    data
  })
} // 获取知识库列表
export function getKnowledgeComboList(data) {
  return request({
    url: '/inside/ai/knowledge/getKnowledgeComboList',
    method: 'post',
    data
  })
}

// 获取销售机会列表
export function getSalesOpportunityList(data) {
  return request({
    url: '/inside/ai/chat/record/business/getOpportunityList',
    method: 'post',
    data
  })
}

// 获取跟进方式列表
export function getCommunicateTypeList(data) {
  return request({
    url: '/inside/ai/chat/record/business/getCommunicateTypeList',
    method: 'post',
    data
  })
}

// 重新提炼
export function createRetryTask(data) {
  return request({
    url: '/inside/ai/chat/createRetryTask',
    method: 'post',
    data
  })
}

// 校验是否有AI看板权限
export function checkAiBoardPermission(data) {
  return request({
    url: '/inside/aiAgent/checkBoardView',
    method: 'post',
    data
  })
}
// 获取跟进助手样式
export function getMeetingStyleType(data) {
  return request({
    url: '/inside/ai/chat/record/business/getMeetingStyleType',
    method: 'post',
    data
  })
}
// 获取录音时长放出白名单
export function getRecordDurationWhiteList(data) {
  return request({
    url: '/inside/ai/chat/record/business/getMeetingRecordTime',
    method: 'post',
    data
  })
}

// 获取线索列表
export function getClueList(data) {
  return request({
    url: '/inside/ai/chat/record/getChatRecordClueList',
    method: 'post',
    data
  })
}

// 【三方导入】获取待发送文件数量
export function getPendingFileCount(data) {
  return request({
    url: '/inside/badge/deviceData',
    method: 'post',
    data
  })
}

// 获取常用提示词列表
export function getCustomPromptTemplateList(data) {
  return request({
    url: '/inside/ai/prompt/getCustomPromptTemplateList',
    method: 'post',
    data
  })
}

// 新增常用提示词
export function addCustomPromptTemplate(data) {
  return request({
    url: '/inside/ai/prompt/addCustomPromptTemplate',
    method: 'post',
    data
  })
}

// 改变订阅状态
export function changeSubscribeStatus(data) {
  return request({
    url: '/inside/ai/prompt/openSubscribe',
    method: 'post',
    data
  })
}

// 删除常用提示词
export function deleteCustomPromptTemplate(data) {
  return request({
    url: '/inside/ai/prompt/deleteCustomPromptTemplate',
    method: 'post',
    data
  })
}

// 更新常用提示词
export function updateCustomPromptTemplate(data) {
  return request({
    url: '/inside/ai/prompt/updateCustomPromptTemplate',
    method: 'post',
    data
  })
}

// 获取线索补全列表
export function getClueSupplementList(data) {
  return request({
    url: '/inside/clue/supplement/list',
    data
  })
}

// 获取线索补全状态
export function getClueSupplementStatus(data) {
  return request({
    url: '/inside/clue/supplement/status',
    data
  })
}

// 下载线索补全模版
export function downloadClueExcelTemplate(data) {
  return request({
    url: '/inside/ai/clueExcel/template/download',
    data
  })
}

// 上传线索补全模版
export function uploadClueExcelTemplate(data) {
  return request({
    url: '/inside/ai/clueExcel/upload',
    data
  })
}

// 一键入库线索
export function addClueSupplement(data) {
  return request({
    url: '/inside/clue/supplement/add',
    data
  })
}

// 快捷操作-新建跟进记录【本地/智能硬件导入】
export function quickActionsCreateTask(data) {
  return request({
    url: '/inside/ai/quickActions/createTask',
    data
  })
}

// 日程助手 - 跟进 - 录音 - 提交
export function submitAnalysis(data) {
  return request({
    url: '/inside/schedule/submitAnalysis',
    data
  })
}

// 快捷操作-新建跟进记录【本地/智能硬件导入】 日程助手场景 需要绑定数据
export function blindCommunicateAndPlan(data) {
  return request({
    url: '/inside/schedule/blindCommunicateAndPlan',
    data
  })
}

// 日程助手 - 推荐任务 - 加入访客计划后，绑定数据
export function blindAddPlan(data) {
  return request({
    url: '/inside/recommended/add/plan',
    data
  })
}

// 开始录音
export function startRecording(data) {
  return request({
    url: '/inside/schedule/startRecording',
    data
  })
}

// 停止录音
export function stopRecording(data) {
  return request({
    url: '/inside/schedule/stopRecording',
    data
  })
}

// Cancel recording
export function cancelRecording(data) {
  return request({
    url: '/inside/schedule/cancelRecording',
    data
  })
}

// 选择客户
export function selectCustomer(data) {
  return request({
    url: '/inside/intention/selected',
    data
  })
}

// 获取无效配置
export function getInvalidConfig(data) {
  return request({
    url: '/inside/ai/meetingAssistantConfig/getInvalidConfig',
    data
  })
}

// 更新无效配置
export function updateInvalidConfig(data) {
  return request({
    url: '/inside/ai/meetingAssistantConfig/updateInvalidConfig',
    data
  })
}

// 获取角色权限列表
export function getRoleList(data) {
  return request({
    url: '/inside/meetingOverview/role/list',
    data
  })
}

// 获取组织架构（部门及用户树）
// isLicense  0或不传：仅拥有 AI 权限的用户；1：所有用户
export function getDepartmentUserTree(data) {
  return request({
    url: '/inside/meetingOverview/department/user/tree',
    data
  })
}

// ****************************************陪练助手start***************************************
// 查询专项训练列表
export function getThemePracticeTaskList(data) {
  return request({
    url: '/inside/ai/themePracticeTask/list',
    method: 'post',
    data
  })
}
// 创建专项训练

export function createThemePracticeTask(data) {
  return request({
    url: '/inside/ai/themePracticeTask/create',
    method: 'post',
    data
  })
}

// 提炼任务
export function extractThemePracticeTask(data) {
  return request({
    url: '/inside/ai/themePracticeTask/extract',
    method: 'post',
    data
  })
}

// 查询提炼任务结果
export function getThemePracticeTaskExtractResult(data) {
  return request({
    url: '/inside/ai/themePracticeTask/extractResult',
    method: 'post',
    data
  })
}

// 预览客户画像
export function previewThemePracticeTaskProfiles(data) {
  return request({
    url: '/inside/ai/themePracticeTask/previewProfiles',
    method: 'post',
    data
  })
}

// 查询预览客户画像结果
export function getThemePracticeTaskPreviewProfilesResult(data) {
  return request({
    url: '/inside/ai/themePracticeTask/previewProfilesResult',
    method: 'post',
    data
  })
}

// // 编辑专项训练
// export function updateThemePracticeTask(data) {
//   return request({
//     url: '/inside/ai/themePracticeTask/update',
//     method: 'post',
//     data
//   })
// }

// 查询专项训练详情
export function getThemePracticeTaskDetail(data) {
  return request({
    // url: '/inside/ai/themePracticeTask/detail',
    url: '/inside/ai/themePracticeTask/get',
    method: 'post',
    data
  })
}

// 删除专项训练前检查
export function deleteCheckThemePracticeTask(data) {
  return request({
    url: '/inside/ai/themePracticeTask/deleteCheck',
    method: 'post',
    data
  })
}

// 删除专项训练
export function deleteThemePracticeTask(data) {
  return request({
    url: '/inside/ai/themePracticeTask/delete',
    method: 'post',
    data
  })
}
// *****************************************陪练助手end**************************************
